import { HeroTextSection } from '../types/heroTextSection'
import { makeStyles } from 'tss-react/mui'
/**
 * useHide is a custom hook which returns a string
 * based on the devices we wanna hide the section on.
 * Screen sizes:
    Deivce     min         max
    Desktops   1440        3450
    Laptops    1024        1439
    Tablets     768        1023
    Mobiles     320         767
 * @param hideOn Array of device types which we want to hide the section on
 * @returns A string of classNames that either shows or hides a particular section based on the current device & `hideOn` array
 */
export default function useHide(hideOn: HeroTextSection['hideOn']): string {
  const { classes } = useStyles()
  const classNames = hideOn?.map((v) => classes[`hide${v}`]) ?? []
  return classNames.join(' ')
}

const useStyles = makeStyles()((theme) => ({
  hideDesktops: {
    [theme.breakpoints.up('laptop')]: {
      '&&': {
        display: 'none',
      },
    },
  },

  hideLaptops: {
    [theme.breakpoints.between(
      theme.breakpoints.values.tablet,
      theme.breakpoints.values.laptop
    )]: {
      '&&': {
        display: 'none',
      },
    },
  },

  hideTablets: {
    [theme.breakpoints.between(
      theme.breakpoints.values.mobile,
      theme.breakpoints.values.tablet
    )]: {
      '&&': {
        display: 'none',
      },
    },
  },

  hideMobiles: {
    [theme.breakpoints.down(theme.breakpoints.values.mobile)]: {
      '&&': {
        display: 'none',
      },
    },
  },
}))
